import { createImportFiles } from '~/lib/prompts/base/create-import-files';
import type { FileMap } from '~/lib/stores/files';
import { WORK_DIR } from '~/utils/constants';
import { createIgnoreCheckForFileMap } from '~/utils/ignore';

export function fileMapToArray(fileMap: FileMap) {
  const hiddenFiles: Array<string> = [];

  const isIgnored = createIgnoreCheckForFileMap(fileMap);

  const files = Object.entries(fileMap).flatMap(([filePath, file]) => {
    const relativePath = filePath.substring(WORK_DIR.length + 1);

    if (!file) {
      return [];
    }

    if (file.type === 'folder') {
      return [];
    }

    if (
      isIgnored({
        path: relativePath,
        contents: file.content,
        isBinary: file.isBinary,
      })
    ) {
      hiddenFiles.push(filePath);
      return [];
    }

    return { path: relativePath, content: file.content, lastModified: file.lastModified };
  });

  return { visible: files, hidden: hiddenFiles };
}

export function fileMapToImportFiles(fileMap: FileMap) {
  const { visible, hidden } = fileMapToArray(fileMap);

  return createImportFiles(visible, hidden);
}
